import Image from 'shared/components/Image';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

export default styled(Image)`
  display: block;
  margin-top: ${SPACINGS.base * 2}px;
  margin-bottom: ${SPACINGS.base * 2}px;
  height: ${(props) => {
    if (props.theme.logoWidth) {
      // object-fit is contain so aspect ratio is maintained and sizing solely depends on width
      return 'unset';
    } else {
      return props.theme.logoHeight || '100%';
    }
  }};
  width: ${(props) => props.theme.logoWidth || '100%'};
  object-fit: contain;
`;
